import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams, ToastController } from 'ionic-angular';
import { LoaderProvider } from '../../../providers/loader/loader';
import { RegistrationModel, UserProvider } from '../../../providers/user/user';
import { SessionProvider } from '../../../providers/session/session';
import { EventProvider } from '../../../providers/event/event';
import { InBrowserPage } from '../../browser/inbrowser';
import { GpsTracker } from '../../../tracker/gps-tracker';
import { GlobalUtil } from '../../../tracker/global-utils';
import { P } from '@angular/core/src/render3';
import { AppDetectorProvider } from '../../../providers/detector/detector';

/**
 * Generated class for the RegistrationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-id-registration',
  templateUrl: 'id-registration.html'
})
export class IdRegistrationPage {

  PRE_ID_KEY: string = "hellaspecial";
  POST_ID_KEY: string = "@production.com";

  rememberMe: boolean = true;
  id: string = "";
  eventId;
  registrationClosed: boolean = false;
  resolve = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private userService: UserProvider,
    public app: App,
    private loadingCtrl: LoaderProvider,
    private translate: TranslateService,
    private toastCtrl: ToastController,
    private sessionService: SessionProvider,
    private eventService: EventProvider,
    private detector: AppDetectorProvider) {

    this.eventId = GlobalUtil.getInstance().currentEventID;
    console.log('GpsTracker.currentEventID: ', GlobalUtil.getInstance().currentEventID);

    this.resolve = this.navParams.get('resolve');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegistrationPage');
  }

  ionViewWillLeave() {
    if (this.resolve) {
      if (this.id.length > 0 && this.sessionService.isLoged)
        this.resolve(true);
      else {
        this.resolve(false);
      }
    }
  }

  onRegister() {
    this.eventService.getPage(`event/${GlobalUtil.getInstance().currentEventID}/raceresult/register-url`).then((link) => {
      console.log('link: ', link);
      if (link.length < 1) {
        this.registrationClosed = true;
      } else {
        (this.app.getRootNav() as NavController).push(InBrowserPage, { link: link });
      }
    });
  }

  login(popAllowed: boolean = true) {
    if (this.sessionService.isLoged) {
      this.relogin();
    }

    let loginId = this.PRE_ID_KEY + this.id + this.POST_ID_KEY;
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    this.userService.registerById(loginId, this.id).then(result => {
      if (!result.hasOwnProperty('success')) {
        this.completeLogin(popAllowed, loginId, loader);
        console.log('login-2.1: ', result);
      } else {
        console.log('login-2.2: ', result);
        this.userService.loginById(loginId, this.id).then((result) => {
          console.log('login-3.1: ', result);
          if (result) {
            this.completeLogin(popAllowed, loginId, loader);
            console.log('login-3.2: ', result);
          } else {
            this.toastCtrl
              .create({
                message: this.translate.instant('LOGIN_ERROR_NOT_VALID_CREDENTIALS'),
                showCloseButton: true,
                duration: 4000
              })
              .present();

            loader.dismiss();
          }
        });
      }
    });

  }

  completeLogin(popAllowed, loginId, loader) {
    this.eventService.registerForEvent(GlobalUtil.getInstance().currentEventID).then((imageLink) => {
      console.log('registerForEvent: ');

      loader.dismiss();

      if (!imageLink) {
        this.toastMessage(this.translate.instant('INVALID_RACE_RESULT_ID'));
        this.logout();
        return;
      }

      this.onLogin();
      this.sessionService.saveLogin({ email: loginId, password: "unset" });
      if (popAllowed) (this.app.getRootNav() as NavController).pop();
    });
  }

  onLogin() {
    this.sessionService.isLoged = true;

    this.sessionService.profile.surName = this.id;

    console.log(this.sessionService);

    this.checkForOrganizerLogin();
  }

  checkForOrganizerLogin() {
    if (this.sessionService.profile.status.toLocaleUpperCase().includes("VERANSTALTER")) {
      this.toastCtrl.create({
        message: this.translate.instant('ORGANIZER_LOGIN_MESSAGE'),
        duration: 5000
      }).present();
      this.userService.logout();
    }
  }

  checkIfLoged() {
    return this.sessionService.isLoged;
  }

  getLogedId() {
    this.sessionService.getLogin().then((model) => {
      console.log('model: ', model.email);
      let email = model.email;
      this.id = email.slice(this.PRE_ID_KEY.length, (model.email.length - this.POST_ID_KEY.length));
    });
  }

  logout() {
    this.userService.logout();
  }


  relogin() {
    this.userService.logout().then(() => {
      this.login((this.resolve) ? true : false);
    });
  }


  toastMessage(message) {
    this.toastCtrl.create({
      message: message,
      position: 'top',
      duration: 3000
    }).present();
  }


}



// WEBPACK FOOTER //
// /src/pages/login/id-registration/id-registration.ts